import { createElement } from "react";
import './Title.css';

const Title = ({title, icon}) => (<h1 className='hl'>{icon && createElement(icon)}{title}</h1>)

export default Title;
